import React, { useState } from 'react'
import { SubmitHandler } from 'react-hook-form'
import { Box, Typography } from 'transfix-ui/core'
import { useUserDetails } from 'utils/hooks'
import { useVerifyAccountMutation } from '../graphql/VerifyAccount'
import { VerifyPasswordForm } from './VerifyPasswordForm/VerifyPasswordForm'
import { TVerifyPasswordSchema } from './VerifyPasswordForm/VerifyPasswordSchema'

interface IVerifyAccountStepProps {
  onCancel: () => void
  /**
   * called when the account was verified
   */
  onVerificationSuccess: () => void
  loading?: boolean
  errorMessage?: string
}

const VerifyDispatcherAccount = ({
  errorMessage,
  loading,
  onCancel,
  onVerificationSuccess,
}: IVerifyAccountStepProps) => {
  const [alertMessage, setAlertMessage] = useState<string>('')
  const [verifyAccountMutation] = useVerifyAccountMutation()
  const { userDetails } = useUserDetails()
  const { email, firstName, lastName } = userDetails || {}

  const submitHandler: SubmitHandler<TVerifyPasswordSchema> = async form => {
    try {
      setAlertMessage('')
      const result = await verifyAccountMutation({
        variables: { input: { password: form.password } },
      })
      if (result.errors?.length) {
        throw new Error(result.errors[0].message)
      }
      if (!result.data?.verifyUserAccount?.success) {
        setAlertMessage("Sorry, we didn't recognize that password.")
        return
      }

      onVerificationSuccess()
    } catch (e) {
      setAlertMessage('Sorry, something went wrong.')
    }
  }

  return (
    <Box>
      <Typography variant='body2'>
        Before you permanently delete your account, please enter your password.
      </Typography>
      <Box paddingY='12px'>
        <Typography color='textSecondary' variant='caption'>
          Email Address
        </Typography>
        <Typography variant='body2'>{email}</Typography>
      </Box>

      <Box paddingY='12px'>
        <Typography color='textSecondary' variant='caption'>
          First Name
        </Typography>
        <Typography variant='body2'>{firstName}</Typography>
      </Box>

      <Box paddingY='12px'>
        <Typography color='textSecondary' variant='caption'>
          Last Name
        </Typography>
        <Typography variant='body2'>{lastName}</Typography>
      </Box>

      <VerifyPasswordForm
        onSubmitSuccess={submitHandler}
        onCancel={onCancel}
        alertMessage={alertMessage || errorMessage}
        loading={loading}
      />
    </Box>
  )
}

export default VerifyDispatcherAccount
